var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.content
  }, [_c('div', {
    class: _vm.$style.poster
  }, [_c('residency-poster', {
    attrs: {
      "slot": "poster"
    },
    slot: "poster"
  })], 1), _c('div', {
    class: _vm.$style.main
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('screen-header', {
    attrs: {
      "title": _vm.$t('registration.currency.title'),
      "is-desktop": _vm.isDesktop
    }
  }, [_c('localization-controller', {
    attrs: {
      "slot": "toolbar",
      "language": _vm.language,
      "inverted-color": ""
    },
    slot: "toolbar"
  })], 1)], 1), _vm.$validate.isNotEmptyArray(_vm.currencies) ? _c('div', {
    class: _vm.$style.form
  }, [_c('div', {
    directives: [{
      name: "scrollbar",
      rawName: "v-scrollbar",
      value: {
        id: "scrollbar-".concat('scrollbarId')
      },
      expression: "{ id: `scrollbar-${'scrollbarId'}` }"
    }],
    class: _vm.$style.list
  }, [_c('scrollbar-vertical', {
    class: _vm.$style.scrollbar,
    attrs: {
      "id": "scrollbar-".concat('scrollbarId')
    }
  }), _c('collapsible-list', {
    attrs: {
      "active-idx": _vm.selectedIdx,
      "language": _vm.language
    }
  }, _vm._l(_vm.formattedCurrencies, function (currency, idx) {
    return _c('currency-panel', {
      key: idx,
      attrs: {
        "data-test": "projectCurrency".concat(currency.code),
        "currency": currency
      },
      on: {
        "click": function click($event) {
          return _vm.handleSelect(idx);
        }
      }
    });
  }), 1)], 1)]) : _vm._e(), _vm.isShownFooter ? _c('div', {
    class: _vm.$style.footer
  }, [_vm.isUzCurrency ? _c('div', {
    class: _vm.$style.message
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('registration.currency.additional.title')))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('registration.currency.additional.uz.one')))])]), _c('p', [_vm._v(_vm._s(_vm.$t('registration.currency.additional.message')))])]) : _vm._e(), _c('div', {
    class: _vm.$style.policy,
    domProps: {
      "innerHTML": _vm._s(_vm.displayPolicyByCurrency)
    }
  }), _c('div', {
    class: _vm.$style.submit
  }, [_c('simple-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('registration.currency.submit')) + " ")])], 1)]) : _vm._e()])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }